module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_9016.881e0a04.png";